import React, { Component } from 'react';
import ModalConfirm from '../../ModalConfirm';
import Loading from '../../Loading';

class EtapaResumo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            notaSelecionada: ""
        }

        this.onChange = this.onChange.bind(this);
    }

    async componentDidMount() {
        if(typeof this.props.nota !== 'undefined' && this.props.nota !== "") {
            this.setState({ notaSelecionada: this.props.nota.toString() });
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.nota !== prevProps.nota) {
            this.setState({ notaSelecionada: this.props.nota.toString() });
        }
    }

    onChange(event) {
        this.setState({ notaSelecionada: event.target.value });
        if(this.props.onChangeNota) this.props.onChangeNota(event.target.value);
    }

    render() {
        return (<div>

            {this.props.loading && <Loading />}

            {!this.props.loading && <React.Fragment>

                <div className="edb-large edb-text-bold edb-margin-bottom">
                    {this.props.estudoFinalizado && <span className="edb-margin-left"><i className="edb-xlarge adap-text-green far fa-check-circle" title="Estudo finalizado"></i></span>} Faça um resumo
                </div>

                <textarea style={{ width: "100%", height: "150px", borderRadius: "5px" }}
                    value={this.props.resumo}
                    onChange={(event) => this.props.onChangeResumo(event.target.value)}
                    disabled={this.props.resumoEnviado}>
                </textarea>

                {this.props.resumoEnviado  && !this.props.correcao && <div className="edb-center edb-text-bold edb-padding">
                    Seu resumo já foi enviado!
                </div>}

                {!this.props.comentario && !this.props.correcao && <div className="edb-round adap-light-gray edb-padding edb-margin-bottom">
                    Depois que seu professor revisar o resumo, sua nota e comentários aparecerão aqui.
                </div>}

                <ModalConfirm isOpen={this.props.modalConfirmarEnviarResumo && !this.props.resumoEnviado}
                    style={{ width: "320px", marginTop: "40px" }}
                    title="Tem certeza que deseja enviar o resumo?"
                    content={<div>
                        <p>Uma vez enviado, você não poderá fazer alterações. Portanto, confira mais uma vez o texto antes de enviar.</p>
                    </div>}
                    confirmText="Sim, quero enviar o resumo."
                    confirmLoadingText="Enviando, por favor aguarde..."
                    onClickConfirm={this.props.onEnviarResumo}
                    loadingConfirm={this.props.loadingEnviarResumo}
                    cancelText="Não, ainda vou conferir"
                    onClickCancel={this.props.onCancelarEnviarResumo}
                />
            </React.Fragment>}

            {(this.props.correcao || this.props.comentario) &&  <div>
                <label className="edb-text-bold edb-margin-top">Comentário sobre o resumo:</label>
                <textarea style={{ width: "100%", height: "150px", borderRadius: "5px" }}
                    value={this.props.comentario}
                    onChange={(event) => this.props.onChangeComentario(event.target.value)}
                    disabled={!this.props.correcao}>
                </textarea>

                <label className="edb-text-bold edb-margin-top">Nivel de compreensão do conteúdo:</label>
                <div className="edb-margin-bottom">
                    <label className="edb-inline edb-margin-large-right">
                        <input type="radio" name="notaResumo" value="120"
                            onChange={this.onChange}
                            disabled={!this.props.correcao}
                            checked={this.state.notaSelecionada && this.state.notaSelecionada.toString() === "120"}/>
                        <span className="edb-margin-small-left"> Bom</span>
                    </label>

                    <label className="edb-inline edb-margin-large-right">
                        <input type="radio" name="notaResumo" value="0"
                            onChange={this.onChange}
                            disabled={!this.props.correcao}
                            checked={this.state.notaSelecionada && this.state.notaSelecionada.toString() === "0"}/>
                        <span className="edb-margin-small-left">Regular</span>
                    </label>

                    <label className="edb-inline edb-margin-large-right">
                        <input type="radio" name="notaResumo" value="-80"
                            onChange={this.onChange}
                            disabled={!this.props.correcao}
                            checked={this.state.notaSelecionada && this.state.notaSelecionada.toString() === "-80"}/>
                        <span className="edb-margin-small-left">Ruim</span>
                    </label>
                </div>
            </div>}

        </div>);
    }
}

export default EtapaResumo;